import { on } from "@ngrx/store";
import { VendorState } from "../vendor.state";
import { VendorsActions } from "./vendors.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// HELPER: Update vendor state within PagesStore
// ============================================================================

function withVendor(state: PagesStore, updater: (vendor: VendorState) => VendorState): PagesStore {
    return { ...state, vendor: updater(state.vendor) };
}

// ============================================================================
// VENDORS LIST REDUCER (flattened structure)
// ============================================================================

const load = on(
    VendorsActions.load,
    (state: PagesStore) => withVendor(state, vendorState => ({
        ...vendorState,
        loadingList: true,
    })),
);

// loadSuccess saves everything in one action
const loadSuccess = on(
    VendorsActions.loadSuccess,
    (state: PagesStore, { vendors, pagination, params }) => withVendor(state, vendorState => ({
        ...vendorState,
        vendors,
        loaded: true,
        pageNumber: pagination?.pageNumber ?? 1,
        pageSize: pagination?.pageSize ?? 50,
        totalCount: pagination?.totalItemCount ?? 0,
        sortProperty: params.sorting.sortProperty,
        sortAscending: params.sorting.sortAscending,
        searchFilter: params.searchFilter,
        loadingList: false,
        error: null,
    })),
);

const loadFailure = on(
    VendorsActions.loadFailure,
    (state: PagesStore, { error }) => withVendor(state, vendorState => ({
        ...vendorState,
        loadingList: false,
        error,
    })),
);

const invalidate = on(
    VendorsActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withVendor(state, vendorState => ({
        ...vendorState,
        loaded: false,
    })),
);

const setVisibleColumns = on(
    VendorsActions.setVisibleColumns,
    (state: PagesStore, { visibleColumns }) => withVendor(state, vendorState => ({
        ...vendorState,
        visibleColumns,
    })),
);

export const vendorsReducer = [load, loadSuccess, loadFailure, invalidate, setVisibleColumns];
